import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "header"
};
export default {
  __name: 'CardHeader',
  props: {
    title: {
      type: String,
      default: '模块标题'
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1);
    };
  }
};